<div class="undo-redo-controls">
  <button
    mat-icon-button
    [disabled]="!canUndo"
    (click)="onUndo()"
    matTooltip="{{ ('PRESENTER.UNDO' | translate) + ' (' + undoShortcutLabel + ')' }}"
    class="undo-button"
  >
    <gb-icon height="18px" [library]="IconLibrary.material" icon="undo"></gb-icon>
  </button>

  <button
    mat-icon-button
    [disabled]="!canRedo"
    (click)="onRedo()"
    matTooltip="{{ ('PRESENTER.REDO' | translate) + ' (' + redoShortcutLabel + ')' }}"
    class="redo-button"
  >
    <gb-icon height="18px" [library]="IconLibrary.material" icon="redo"></gb-icon>
  </button>

  <button
    mat-icon-button
    (click)="onCopy()"
    matTooltip="{{ ('PRESENTER.COPY' | translate) + ' (' + copyShortcutLabel + ')' }}"
    class="copy-button"
  >
    <gb-icon height="18px" icon="copy"></gb-icon>
  </button>

  <button
    mat-icon-button
    (click)="onPaste()"
    matTooltip="{{ ('PRESENTER.PASTE' | translate) + ' (' + pasteShortcutLabel + ')' }}"
    class="paste-button"
  >
    <gb-icon height="18px" icon="clipboard"></gb-icon>
  </button>

  <button
    mat-icon-button
    (click)="onDelete()"
    matTooltip="{{ ('PRESENTER.DELETE' | translate) + ' (' + deleteShortcutLabel + ')' }}"
    class="delete-button"
  >
    <gb-icon height="18px" icon="trash"></gb-icon>
  </button>
</div>
